<div class="projects mb-4" *ngIf="!simulacion" >
    <div class="card">
            <div class="card-header header-background">
                  <div class="row">
                      <div class="col-sm-6">
                          <h2>Instrumento de Autoevaluación</h2>
                      </div>
                  </div>
            </div>
    

            <div>

                <div id="myTabContent" class="tab-content" style="padding: 20px 50px;">
                
                    <div>
        
                        <div class="row" style="margin-top: 20px;">
                            <div class="col-lg-1">
                                <p class="title-descriptor">Filtrar Por:</p>
                            </div>
                            <div class="col-lg-2" *ngIf="region == null">
                                <mat-form-field>
                                    
                                    <mat-label>Región</mat-label>
                                    <mat-select id="region" name="region" class="selectMedio"  (selectionChange)="seleccionarRegion($event.value)">
                                        <mat-option [value]="0">Seleccione Región</mat-option>
                                        <mat-option [value]="regiones.idRegion" *ngFor="let regiones of regiones">{{regiones.nombre}}</mat-option>
                                    </mat-select>
                    
                                </mat-form-field>  
                            </div>
                            <div class="col-lg-2">
                                <mat-form-field>
                                    <mat-label>Comuna</mat-label>
                                    <mat-select id="comuna" class="selectMedio" name="comuna" (selectionChange)="seleccionarComuna($event.value)">
                                        <mat-option [value]="0">Seleccione Comuna</mat-option>
                                        <mat-option [value]="comunas.idComuna" *ngFor="let comunas of arrayComunas">{{comunas.nombre}}</mat-option>
                                    </mat-select>
                    
                                </mat-form-field>   
                            </div>
                            <div class="col-lg-2">
                                <mat-form-field>
                                    <mat-label>Programa</mat-label>
                                    <mat-select  placeholder="" floatlLabel="never" id="programa" class="selectMedio" name="programa" (selectionChange)="seleccionarPrograma($event.value)">
                                        <mat-option value="0">Seleccione Programa</mat-option>
                                        <mat-option [value]="programas.idTablaMaestra" *ngFor="let programas of programas">{{programas.descripcionLarga}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-lg-5 d-flex justify-content-end" >
                            <input class="form-control me-sm-2" type="text" (keyup.enter)="buscar(palabraClave)" [(ngModel)]="palabraClave" style="width: 300px; height: 45px;" placeholder="Buscar">
                                    <button class="btn btn-secondary" type="submit" (click)="buscar(palabraClave)" style="width: 130px;height: 45px;"><i class="fas fa-search"></i> Buscar</button>
                            </div>
                        </div>
                    
                        <div class="row">
                            <div class="d-flex justify-content-end">
                                <a class="btn" [attr.href]="apiEndpoint + 'instrumentoAutoevaluacion/descargaAdmin?idRegion=' + idRegion + '&idComuna=' + idComuna + '&idPrograma=' + idPrograma + '&palabraClave=' + palabraClave" target=”_blank”  style="width: 40px;height: 37px;border-radius: 50%;background-color: #597CEE;color: #fff;padding-top: 5px;"> <i class="fa fa-download"></i> </a>
                            </div>
                        </div>
                       
                    
                        <div>
                    
                            <table class="tables-info" mat-table [dataSource]="dataSource" matSort>
                    
                                <ng-container matColumnDef="region">
                                    <th mat-header-cell *matHeaderCellDef > Región </th>
                                    <td mat-cell *matCellDef="let row" > {{row.region}} </td>
                                </ng-container>
                    
                                <ng-container matColumnDef="comuna">
                                    <th mat-header-cell *matHeaderCellDef > Comuna </th>
                                    <td mat-cell *matCellDef="let row" > {{row.comuna}} </td>
                                </ng-container>
                    
                                <ng-container matColumnDef="modalidad">
                                    <th mat-header-cell *matHeaderCellDef > Modalidad </th>
                                    <td mat-cell *matCellDef="let row" > {{row.modalidad}} </td>
                                </ng-container>

                                <ng-container matColumnDef="programa">
                                    <th mat-header-cell *matHeaderCellDef > Programa </th>
                                    <td mat-cell *matCellDef="let row" > {{row.programa}} </td>
                                </ng-container>
                    
                                <ng-container matColumnDef="codigo">
                                    <th mat-header-cell *matHeaderCellDef > Código JI </th>
                                    <td mat-cell *matCellDef="let row" > {{row.codigo}} </td>
                                </ng-container>
                    
                                <ng-container matColumnDef="jardin">
                                    <th mat-header-cell *matHeaderCellDef > Nombre JI </th>
                                    <td mat-cell *matCellDef="let row" > {{row.nombre}} </td>
                                </ng-container>

                                <ng-container matColumnDef="estado">
                                    <th mat-header-cell *matHeaderCellDef class="centre"> Estado </th>
                                    <td mat-cell *matCellDef="let row" class="centre">
                                        <div *ngIf="row.estado==='No iniciado'"><p style="color: #EE366D;">No Iniciado</p></div> 
                                        <div *ngIf="row.estado==='Iniciado'"><p style="color: #F5BB3F;">Iniciado</p></div> 
                                        <div *ngIf="row.estado==='Finalizado'"><p style="color: #00B09E;">Terminado</p></div>
                                    </td>
                                </ng-container>
                    
                                <ng-container matColumnDef="acciones">
                                    <th mat-header-cell *matHeaderCellDef class="centre"> Acciones </th>
                                    <td mat-cell *matCellDef="let row" class="centre">
                                        <button type="button" class="btn btn-editar" style="width: 40px;height: 37px;border-radius: 50%;background-color: #F5BB3F;color: #fff;padding-top: 5px;" title="Editar" (click)="simular(row)"><i class="fas fa-sign-in-alt"></i> </button>
                                        &nbsp;
                                        <button type="button" class="btn" style="width: 40px;height: 37px;border-radius: 50%;background-color: #597CEE;color: #fff;padding-top: 5px;" title="Ver Archivo" (click)="imprimir(row.idJardinPeriodo)"><i class="fa fa-eye"></i> </button>
                                    </td>
                                </ng-container>
                              
                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                            </table>
                    
                            <mat-paginator
                                [length]="length"
                                [pageIndex]="pageIndex"
                                
                                [pageSizeOptions]="[10, 50, 100]"
                                [showFirstLastButtons]="true"
                                (page)="getServerData($event)">
                            </mat-paginator>
                        </div>
                    </div>
                
                </div>
                

            </div>
    </div>
  </div>

<div *ngIf="simulacion" >
    <app-simulacion-instrumento-autoevaluacion></app-simulacion-instrumento-autoevaluacion>
</div>

<ng-template #modalInforme let-modal class="modal-dialog modal-xl">
    <div class="modal-header" style="padding: 0px " width="100%">
        <h5 id="modalTitleUser" class="titulo-card-amarillo" style="    margin: 25px">Informe Instrumento Autoevaluación</h5>
        <button type="button" class="close" (click)="close()" style="background: none;border: none;font-size: xx-large;">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body" style="padding: 0px;" width="100%">
        <iframe [src]="urlSafe" frameborder="0" width="100%" style="min-height: 700px;" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen> </iframe>
    </div>
</ng-template>

<ngx-spinner></ngx-spinner>